<div class="m-1">
  <h3 class="h6 mt-1">
    {{ "video:edit:modal:tab:advanced_settings" | translate }}
  </h3>
  <p class="fs-14 text-muted">
    {{ "video:edit:modal:tab:advanced_settings:description" | translate }}
  </p>

  <div class="tab-content" id="nav-tabContent">
    <div
      class="tab-pane fade show active"
      id="nav-language-en"
      role="tabpanel"
      aria-labelledby="nav-home-tab"
    >
      <!-- Spaces Video Link Section -->
      <div class="mb-3" *ngIf="!isProcessingNewVideo() && !videoSpacesLink.includes('/videos/null')">
        <label class="form-label w-100 fw-bold">{{ 'video:advanced:spaces:link' | translate }}</label>
        <div class="d-flex align-items-center gap-2 flex-wrap">
          <button
            class="btn btn-outline-primary rounded-pill"
            type="button"
            (click)="openVideoSpacesLink()"
          >
            <i class="fa fa-external-link me-1"></i>
            {{ 'video:advanced:view:video' | translate }}
          </button>
          <button
            class="btn btn-outline-primary rounded-pill"
            type="button"
            (click)="downloadVideo()"
            [disabled]="isDownloading"
          >
            <i class="fa fa-download me-1" *ngIf="!isDownloading"></i>
            <i class="fa fa-spinner fa-spin me-1" *ngIf="isDownloading"></i>
            {{ 'video:advanced:download:video' | translate }}
          </button>
          <input
            type="text"
            class="form-control flex-grow-1"
            [value]="getVideoSpacesLink()"
            readonly
            style="cursor: default; min-width: 200px;"
          />
        </div>
      </div>

      <!-- Processing state after replace -->
      <div class="mb-3 alert alert-info d-flex align-items-center" *ngIf="isProcessingNewVideo()">
        <i class="fa fa-spinner fa-spin me-2"></i>
        <span>{{ 'video:advanced:processing:new' | translate }}</span>
      </div>

      <!-- Replace Video Section -->
      <div class="mb-3">
        <label class="form-label w-100 fw-bold">{{ 'video:advanced:replace:title' | translate }}</label>
        <button
          class="btn btn-outline-primary rounded-pill"
          type="button"
          (click)="openReplaceModal()"
        >
          <i class="fa fa-upload me-1"></i>
          {{ 'video:advanced:replace:button' | translate }}
        </button>
        <p class="fs-14 text-muted mt-1 mb-0">
          {{ 'video:advanced:replace:description' | translate }}
        </p>
      </div>

      <!-- Subtitles Section: videos antiguos sin subtítulos -->
      <div class="mb-3" *ngIf="subtitles">
        <label class="form-label w-100 fw-bold">{{ 'video:subtitles:title' | translate }}</label>

        <p class="fs-14 mb-2" *ngIf="readySubtitles().length">
          {{ 'video:subtitles:ready' | translate }}
          <span class="badge rounded-pill bg-primary ms-1" *ngFor="let subtitle of readySubtitles()">
            {{ 'language:options:' + subtitle.language | translate }}
          </span>
        </p>

        <div class="alert alert-info d-flex align-items-center" *ngIf="subtitlesInProgress()">
          <i class="fa fa-spinner fa-spin me-2"></i>
          <span>{{ 'video:subtitles:generating' | translate }}</span>
        </div>

        <ng-container *ngIf="!subtitlesInProgress() && !readySubtitles().length">
          <p class="fs-14 text-danger mb-2" *ngIf="subtitlesFailed()">
            {{ 'video:subtitles:failed' | translate }}
          </p>
          <button
            class="btn btn-outline-primary rounded-pill"
            type="button"
            (click)="generateSubtitles()"
            [disabled]="isGeneratingSubtitles || isProcessingNewVideo()"
          >
            <i class="fa fa-closed-captioning me-1" *ngIf="!isGeneratingSubtitles"></i>
            <i class="fa fa-spinner fa-spin me-1" *ngIf="isGeneratingSubtitles"></i>
            {{ (subtitlesFailed() ? 'video:subtitles:retry' : 'video:subtitles:generate') | translate }}
          </button>
          <p class="fs-14 text-muted mt-1 mb-0">
            {{ 'video:subtitles:description' | translate }}
          </p>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<!-- <hr [ngClass]="{'my-5': !videoEditService.isModal}">

<div class="pure-control-group">
  <label class="common-form-title mr-2" style="display: inline-block;margin-right: 10px" for="video-vixy-id">Vixy ID</label>
  <input [(ngModel)]="video.source.external_id" class="form-control" style="display: inline-block;width: 200px;" id="video-vixy-id" name="video-vixy-id" type="text" disabled=""
    value="">
</div> -->
